import { Field } from "react-final-form";

import InputCheckbox from "@components/Form/Checkbox";
import Heading from "@components/Heading";
import { composeFormValidators, isRequired } from "@lib/validations";

const PolicyDeliverySection = () => (
  <div className="space-y-[20px]">
    <div className="bg-white p-[16px]">
      <Field
        name="policyDelivery.digitalPolicy"
        component={InputCheckbox}
        type="checkbox"
        label="Declar ca sunt de acord cu emiterea si transmiterea politei de asigurare in format electronic, la adresa de email furnizata."
        required
        validate={composeFormValidators(isRequired())}
        className="text-[14px] font-normal cursor-pointer max-w-fit"
      />
    </div>
  </div>
);

export default PolicyDeliverySection;
